import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'errorFilter'
})
export class ErrorFilterPipe implements PipeTransform {

  transform(items: any[], fieldName: string): any[] {
    if (!items) {
      return [];
    }
    return items.filter(item => {
      return item.field === fieldName;
    });
  }

}
